import React, {useEffect, useMemo, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

import {parseLocalString, isToday} from '../../utilities/utils'
import TimeLineItem from './TimeLineItem';
import { Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
		width: "50%",
		backgroundColor: theme.palette.background.paper,
		display: "flex",
		flexDirection: "column",
		flex: 1,
		justifyContent: "space-between",
	},
	paginator: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-end",
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		flex: "0 0 50px",
		padding: "10px",
		gap: 5,
	},
	events: {
		marginTop: theme.spacing(1),
		overflow: "auto",
	},
	label: {
		lineHeight: "37px",
	},
}));

export default function CommonTimeLine(props) {
  //states
	const [pageAll, setPageAll] = useState(1);
  const classes = useStyles();
  const equipName = props.equipName;
  const showImportantOnly = props.showImportantOnly;
  const rows = props.rows;
  const otherRows = useMemo(() => rows?.filter(i => i) ?? [],[rows])
  const othersCount = rows ? rows.length : 0;
  const rowPerPage = 12;
  const totalPagesAll = Math.ceil(otherRows.length / rowPerPage);
	const visibleRowsAll = otherRows?.slice(
		rowPerPage * (pageAll - 1),
		rowPerPage * pageAll
	);
  
  const handleOnPageAllChange = (e) => setPageAll(e.target.value);
  
  useEffect(() => {
    setPageAll(1);
  },[rows])

  const paginator = (pageValue, totalPages,setter) => (
		<div className={classes.paginator}>
			<Button
				variant="contained"
				color="primary"
				size="small"
				onClick={() => setter(1)}>
				В начало
			</Button>
			<Button
				variant="contained"
				color="primary"
				onClick={() => pageValue > 1 && setter((prev) => --prev)}>
				Пред.
			</Button>
			<Typography className={classes.label}>Страница</Typography>
			<input
				type="number"
				min={1}
				max={totalPages}
				value={pageValue}
				onChange={handleOnPageAllChange}
			/>
			<Typography className={classes.label}>из {totalPages}</Typography>
			<Button
				variant="contained"
				color="primary"
				size="small"
				onClick={() =>
					pageValue < totalPages && setter((prev) => ++prev)
				}>
				След.
			</Button>
			<Button
				variant="contained"
				color="primary"
				size="small"
				onClick={() => setter(totalPages)}>
				В конец
			</Button>
		</div>
	);


  return (
		<>
			<Paper className={classes.root}>
				<div className={classes.events}>
					<Typography component="span" variant="h5" color="textPrimary">
						{`Сообщения от ${parseLocalString(props.startDate).split(",")[0]} до ${parseLocalString(props.endDate).split(",")[0]}`} (
						{othersCount} сообщений)
					</Typography>
					{visibleRowsAll?.map((i, ind) => {
						const isImportant = i.Type?.includes("Error");
						return (
							<TimeLineItem
								key={ind.toString()}
								isImportant={isImportant}
								equipName={i.EquipName}
								title={i.Title}
								text={i.Description}
								time={parseLocalString(i.DateTime)}
								details={i.Details}
							/>
						);
					})}
				</div>
				{paginator(pageAll, totalPagesAll, setPageAll)}
			</Paper>
		</>
	);
}